// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2gR9F","overflowing":"ReadFullNote_overflowing__2Ati7"};